import logo from 'assets/img/logo/mizar_icon.svg';
import { useEffect } from 'react';
import IntroJs from 'intro.js';

type Props = {
  onSkipIntro: () => void;
  steps: IntroJs.Options['steps'];
};

export const Intro = ({ steps, onSkipIntro }: Props) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      IntroJs()
        .setOptions({
          steps,
          /* Next button label in tooltip box */
          nextLabel: 'NEXT',
          /* Previous button label in tooltip box */
          prevLabel: 'BACK',
          /* Skip button label in tooltip box */
          skipLabel: 'X',
          /* Done button label in tooltip box */
          doneLabel: 'DONE',
          /* Close introduction when clicking on overlay layer? */
          exitOnOverlayClick: false,
        })
        .start()
        .onexit(function () {
          onSkipIntro();
        });
    }, 100);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="row min-vh-100" data-testid="intro-first-login">
        <div className="col justify-content-center align-self-center align-items-center flex">
          <img src={logo} alt="logo" height="150" />
        </div>
      </div>
    </>
  );
};
